import React from 'react';
import { PencilSimple } from '@phosphor-icons/react';
import { useDashboardV3Data } from './useDashboardV3Data';
import { DashboardV3ProductCard } from './DashboardV3ProductCard';
import { useOneButtonStore } from '../../../../../../store/oneButtonStore';

export type DashboardV3SelectedProductsSectionProps = {
    onOpenProducts: () => void;
};

export const DashboardV3SelectedProductsSection: React.FC<DashboardV3SelectedProductsSectionProps> = ({
    onOpenProducts,
}) => {
    const { products } = useDashboardV3Data();
    const setCommerceHubProductsOpen = useOneButtonStore((s) => s.setCommerceHubProductsOpen);

    const openProducts = () => {
        setCommerceHubProductsOpen(true);
        onOpenProducts();
    };

    return (
        <section className="obd-dashboard-v3-layout__products" aria-label="Selected products">
            <div className="obd-v3-products-section-head">
                <h2 className="obd-dashboard-v3-layout__section-title">Selected products</h2>
                <button
                    type="button"
                    className="obd-v3-products-manage"
                    onClick={openProducts}
                >
                    <PencilSimple size={14} weight="regular" aria-hidden />
                    Manage products
                </button>
            </div>
            <div className="obd-v3-products-grid">
                {products.map((model) => (
                    <DashboardV3ProductCard
                        key={model.kind}
                        model={model}
                        onDesign={openProducts}
                        onUtility={openProducts}
                        onAdders={openProducts}
                        onFinance={openProducts}
                    />
                ))}
            </div>
        </section>
    );
};
